var _html = require('./html')._html;
var _vars = require('./vars')._vars;
// --- AI Search Gating State & Config ---
var aiGatingMeta = {
    isAIGated: false,
    freeQueryUsed: false,
    get queryLimit() {
        return _vars.cfg.queryLimit;
    },
    queriesSeen: 0,
    sessionExpiry: 24 * 60 * 60 * 1000 // 24 hours in milliseconds
};

// --- AI Search Gating Eligibility Logic ---
function syncAIGatingEligibility() {
    try {
        
        if (typeof PageMetadata !== 'undefined' && 
            PageMetadata.authVar && 
            Number(PageMetadata.authVar.authLevel) === 0) {
            window.isAIGatingEligible = true;
        } else {
            window.isAIGatingEligible = null; // Authenticated users or non-full-width pages bypass gating
        }
    } catch (e) {
        console.log('syncAIGatingEligibility exception:', e);
        window.isAIGatingEligible = null;
    }
}

function renderHistory(shared) {
    try {
        // Get conversation history array
        var conversationHistory = sessionStorage.getItem('anonConversationHistory');
        var historyArray = [];
        
        if (conversationHistory) {
            try {
                historyArray = JSON.parse(conversationHistory);
            } catch (e) {
                console.log('Error parsing conversation history:', e);
                return;
            }
        }
        
        // Render all Q&A pairs in the history
        if (historyArray.length > 0) {
            var progressElement = document.querySelector('.ai-search-progress');
            
            historyArray.forEach(function(item, index) {
                if (item.question && item.answer) {
                    if (index === 0) {
                        // First question goes outside .ai-search-asking container
                        progressElement.insertAdjacentHTML('beforebegin', _html.askingQuestion(item.question));
                        // Insert answer for first question
                        progressElement.insertAdjacentHTML('beforebegin', _html.showAnswer(item.answer));
                    } else {
                        // Subsequent questions go inside .ai-search-asking container
                        var askingProgress = document.querySelector('.ai-search-asking .ai-search-progress');
                        if (askingProgress) {
                            askingProgress.insertAdjacentHTML('beforebegin', _html.askingQuestion(item.question));
                            askingProgress.insertAdjacentHTML('beforebegin', _html.showAnswer(item.answer));
                        }
                    }
                    
                    // Remove loading state from the question immediately
                    var questionElements = document.querySelectorAll('.ai-search-question, .ai-search-asking-question');
                    if (questionElements.length > index) {
                        questionElements[index].classList.remove('loading');
                        questionElements[index].classList.remove('current');
                    }
                }
            });
            
            // Re-attach event handlers to follow-up questions after rendering all history
            reattachFollowUpHandlers(shared);
        }
    } catch (e) {
        console.log('renderHistory exception:', e);
    }
}

// Helper function to re-attach click handlers to follow-up questions
function reattachFollowUpHandlers(shared) {
    try {
        var followUpItems = document.querySelectorAll('.follow-up-question-item');
        
        followUpItems.forEach(function(item, index) {
            // Remove old handlers by cloning
            var newItem = item.cloneNode(true);
            if (item.parentNode) {
                item.parentNode.replaceChild(newItem, item);
            } else {
                return;
            }
            
            // Attach click handler
            newItem.addEventListener('click', function() {
                var question = this.getAttribute('data-question');
              if (question) {
                    shared.handleSearch(question);
                    if (typeof wmdPageLink !== 'undefined') {
                        wmdPageLink('ai-search_followup-' + (index + 1));
                    }
                }
            });
            
            // Add keyboard support
            newItem.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    var question = this.getAttribute('data-question');
                   if (question) {
                        shared.handleSearch(question);
                        if (typeof wmdPageLink !== 'undefined') {
                            wmdPageLink('ai-search_followup-' + (index + 1));
                        }
                    }
                }
            });
        });
    } catch (e) {
        console.log('reattachFollowUpHandlers exception:', e);
    }
}
// --- AI Search Gating Initialization ---
function initAIGating(shared) {
    try {
        // Get cookie value for AI queries used
        var aiQueriesMatch = document.cookie.match(/ai_queries_used=(\d+)/);
        if (aiQueriesMatch != null) {
            aiGatingMeta.queriesSeen = Number(aiQueriesMatch[1]);
        }

        // Check session timestamp to ensure 24-hour expiry
        var aiTimestampMatch = document.cookie.match(/ai_query_timestamp=(\d+)/);
        if (aiTimestampMatch != null) {
            var timestamp = Number(aiTimestampMatch[1]);
            var now = Date.now();
            if (now - timestamp > aiGatingMeta.sessionExpiry) {
                // Session expired, reset counters
                aiGatingMeta.queriesSeen = 0;
                document.cookie = 'ai_queries_used=0; path=/; domain=medscape.com; expires=Thu, 01 Jan 1970 00:00:00 GMT';
                document.cookie = 'ai_query_timestamp=; path=/; domain=medscape.com; expires=Thu, 01 Jan 1970 00:00:00 GMT';
            }
        }

        syncAIGatingEligibility();

        if (typeof PageMetadata !== 'undefined' && PageMetadata.authVar && Number(PageMetadata.authVar.authLevel) === 0) {
            if (window.isAIGatingEligible === true && aiGatingMeta.queriesSeen < aiGatingMeta.queryLimit) {
                // Queries available for unknown users
                aiGatingMeta.isAIGated = false;
            } else if (window.isAIGatingEligible === true && aiGatingMeta.queriesSeen >= aiGatingMeta.queryLimit) {
                // Gate subsequent queries for unknown users
                aiGatingMeta.isAIGated = true;
            }
        }

        var fullWidthEl = document.querySelector('.ai-search-full-width-container');
        var queryParams = new URLSearchParams(window.location.search);
        const form = queryParams.get('form');
        const errorCode = queryParams.get('errorCode');
        const icd = queryParams.get('icd');
        if(form && form === 'login' && errorCode) {
            if (shouldGateAIQuery()) {
                if (fullWidthEl) {
                    shared.switchToConversationPage(fullWidthEl);
                }
                renderHistory(shared);
                showAIGate();
            }
        } else if(icd && icd == 'login_success_email_match_fpf') {
            if (fullWidthEl) {
                shared.switchToConversationPage(fullWidthEl);
            }
            renderHistory(shared);
            // Retain the Omniture tracking param (icd=login_success_email_match_fpf)
            // by preserving the query string on the history entry (PROFCORE-34824).
            window.history.pushState({}, document.title, window.location.pathname + window.location.search)
        } else {
            sessionStorage.removeItem('anonConversationHistory');
        }

    } catch (e) {
        console.log('initAIGating exception:', e);
    }
}

// --- AI Search Gating Check Functions ---
function shouldGateAIQuery() {
    return aiGatingMeta.isAIGated && 
           typeof PageMetadata !== 'undefined' && 
           PageMetadata.authVar &&
           Number(PageMetadata.authVar.authLevel) === 0;
}

function markAIQueryUsed() {
    try {
        if (typeof PageMetadata !== 'undefined' && 
            PageMetadata.authVar &&
            Number(PageMetadata.authVar.authLevel) === 0) {
            
            const nextSeen = Number(aiGatingMeta.queriesSeen) + 1;
            const now = Date.now();
            const expiry = new Date(now + aiGatingMeta.sessionExpiry).toGMTString();
            
            // Set cookies for tracking
            document.cookie = `ai_queries_used=${nextSeen}; path=/; domain=medscape.com; expires=${expiry}`;
            document.cookie = `ai_query_timestamp=${now}; path=/; domain=medscape.com; expires=${expiry}`;
            
            // Update state for next query
            aiGatingMeta.queriesSeen = nextSeen;
            
            // Set gating state based on query limit
            if (nextSeen >= aiGatingMeta.queryLimit) {
                aiGatingMeta.isAIGated = true;
            } else {
                aiGatingMeta.isAIGated = false;
            }
            
            aiGatingMeta.freeQueryUsed = true;
        }
    } catch (e) {
        console.log('markAIQueryUsed exception:', e);
    }
}

// --- AI Search Login Gate Banner Functions ---
function appendAIGateBanner() {
    try {
        if (document.querySelector('#fpfWidget')) {
            return; // Banner already exists, no need to append again
        } else {
            document.addEventListener('fpfAppended', function() {
                const fpfWidget = document.querySelector('.ai-gate-banner .ai-gate-content #fpfWidget');
                if (fpfWidget) {
                    fpfWidget.remove(); // Remove duplicate FPF widget if it exists
                }
            })
        }
        
        var widgLang = typeof locale != "undefined" ? locale : (typeof __INITIAL_STATE__ !== 'undefined' && typeof __INITIAL_STATE__.commonStore.lang !== 'undefined') ? __INITIAL_STATE__.commonStore.lang : "en";
        if (widgLang == "us") widgLang = "en";

        // Create banner HTML with FPF widget only (no custom headers)
        const aiGateBannerHtml = `
            <div class="ai-gate-banner">
                <div class="ai-gate-content">
                    <div id="fpfWidget" data-lang="${widgLang}" data-env="${getFPFEnv()}"></div>
                </div>
            </div>
        `;

        // Insert banner in chat interface where answers are rendered
        const progressEls = document.querySelectorAll('.ai-search-progress');
        const progressElement = progressEls[progressEls.length-1];
        if (progressElement && !document.querySelector('#fpfWidget')) {
            progressElement.insertAdjacentHTML('beforebegin', aiGateBannerHtml);
        }

        // Load FPF login system
        loadFPFLoginJS();
        
        // Override FPF content after it loads - multiple approaches
        document.addEventListener('fpfAppended', overrideFPFContent);
        
        // Also try polling for FPF content in case event doesn't fire
        var pollCount = 0;
        var pollInterval = setInterval(function() {
            pollCount++;
            var fpfTitle = document.querySelector('.ai-gate-content #fpfWidget .mdscp-form-title');
            var fpfSubtitle = document.querySelector('.ai-gate-content #fpfWidget .mdscp-form-subtitle');
            
            if ((fpfTitle || fpfSubtitle) || pollCount > 20) { // Found content or timeout after 10 seconds
                clearInterval(pollInterval);
                if (fpfTitle || fpfSubtitle) {
                    overrideFPFContent();
                }
            }
        }, 500);
    } catch (e) {
        console.log('appendAIGateBanner exception:', e);
    }
}

function overrideFPFContent() {
    try {
        // Wait a bit for FPF content to fully render
        setTimeout(function() {
            var header = 'Log in or register for free to continue using Medscape AI';
            var teaser = 'Unlimited access to our entire ecosystem of sites and services';
            
            // Override FPF title using the correct class
            var fpfTitle = document.querySelector('#fpfWidget .mdscp-form-title');
            if (fpfTitle) {
                fpfTitle.textContent = header;
                fpfTitle.classList.add('ai-gate-custom-title');
            }
            
            // Override FPF subtitle using the correct class
            var fpfSubtitle = document.querySelector('#fpfWidget .mdscp-form-subtitle');
            if (fpfSubtitle) {
                fpfSubtitle.textContent = teaser;
                fpfSubtitle.classList.add('ai-gate-custom-subtitle');
            }
            
            // Add custom class to FPF widget for styling overrides
            var fpfWidget = document.querySelector('#fpfWidget');
            if (fpfWidget) {
                fpfWidget.classList.add('ai-gate-fpf-override');
            }
            document.querySelector('.ai-gate-content').classList.add('active');
            document.querySelector('.ai-gate-content').scrollIntoView();
        }, 500);
    } catch (e) {
        console.log('overrideFPFContent exception:', e);
    }
}

function getFPFEnv() {
    try {
        return (typeof _satellite !== 'undefined' && _satellite.getVar) ? 
               _satellite.getVar('Helios Data-Env Domain') : '';
    } catch (e) {
        return '';
    }
}

function loadFPFLoginJS() {
    if (document.querySelector('script[src*="page-fpf"]')) {
        return;
    }
    const head = document.head;
    const env = (typeof _satellite !== 'undefined' && _satellite.getVar) ? _satellite.getVar("Helios URL Domain") : '';
    const urlBase = `https://img.${env}wbmdstatic.com/medscape_v1_static_vue/page-fpf/client/main.es6`;

    // CSS
    const style = document.createElement('link');
    style.href = `${urlBase}.css`;
    style.type = 'text/css';
    style.rel = 'stylesheet';
    head.append(style);

    // JS
    const script = document.createElement('script');
    script.src = `${urlBase}.js`;
    script.type = 'text/javascript';
    script.onload = () => {
        document.dispatchEvent(new CustomEvent('aiGateFpfLoaded'));
        wmdPageLink('ai-search_login-appear');
    };
    head.append(script);
}


function showAIGate() {
    try {
        // Create banner if it doesn't exist
        if (!document.querySelector('.ai-gate-banner')) {
            appendAIGateBanner();
            
            // Store all questions and answers in conversation history
            var questions = document.querySelectorAll('.ai-search-question, .ai-search-asking-question');
            var answers = document.querySelectorAll('.answer');
            var conversationHistory = [];
            
            // Build conversation history array from all Q&A pairs
            for (var i = 0; i < Math.min(questions.length, answers.length); i++) {
                if (questions[i] && answers[i]) {
                    conversationHistory.push({
                        question: questions[i].innerText || questions[i].textContent,
                        answer: answers[i].innerHTML
                    });
                }
            }
            
            // Store the complete conversation history
            if (conversationHistory.length > 0) {
                sessionStorage.setItem('anonConversationHistory', JSON.stringify(conversationHistory));
            }
        }
    } catch (e) {
        console.log('showAIGate exception:', e);
    }
}

// --- New Function to Check and Trigger Gating After Response Completion ---
function checkAndTriggerGatingAfterResponse() {
    try {
        // Only check for anonymous users
        if (typeof PageMetadata !== 'undefined' && 
            PageMetadata.authVar && 
            Number(PageMetadata.authVar.authLevel) === 0 && 
            window.isAIGatingEligible === true) {
            
            // Check if we've reached the query limit
            if (aiGatingMeta.queriesSeen >= aiGatingMeta.queryLimit) {
                // Show gating banner
                showAIGate();
                
                // Disable input fields to prevent further queries
                var modalInput = document.querySelector('#ai-search-input-modal');
                var fullWidthEl = document.querySelector('.ai-search-full-width-container');
                
                if (modalInput) {
                    modalInput.disabled = true;
                }
                
                if(!fullWidthEl) {
                    document.body.classList.add('ai-search-modal-maximized');
                    document.querySelector('.ai-search-footer').classList.add('inactive');
                }
                
                return true; // Gating was triggered
            }
        }
        return false; // No gating needed
    } catch (e) {
        console.log('checkAndTriggerGatingAfterResponse exception:', e);
        return false;
    }
}


// --- Module Exports ---
module.exports = {
    initAIGating: initAIGating,
    shouldGateAIQuery: shouldGateAIQuery,
    markAIQueryUsed: markAIQueryUsed,
    showAIGate: showAIGate,
    checkAndTriggerGatingAfterResponse: checkAndTriggerGatingAfterResponse,
    aiGatingMeta: aiGatingMeta
};
